import React, { useState, useEffect } from "react";
import styled from "styled-components";

import FormGroup from "live/components/forms/ui/form-group";
import SubmitOrCancel from "live/components/forms/ui/submit-or-cancel";

import PerspectivesBox from "./PerspectivesBox";
import { createCustomGroupApi, updateCustomGroupApi, resetPoiApi } from "../../../api/customGroupApi"
import "./../../../../assets/scss/form.scss";
import "./../../../../assets/scss/select.scss";
import i18n from "live/services/i18n";

const CustomGroup = ({
    customGroup,
    company,
    selectCustomGroup,
    reloadCustomGroupList,
}) => {
    const [messageErrorName, setMessageErrorName] = useState("");
    const [messageErrorResponseApi, setMessageErrorResponseApi] = useState();
    const [customGroupSelected, setCustomGroupSelected] = useState({
        name: "",
        description: "",
        perspectiveId: "",
        perspectives: [],
        companyId: company.id,
    });
    useEffect(() => {
        console.log(customGroup)

    }, [customGroup]);
    useEffect(() => {
        if (customGroup.id) {
            console.log(customGroup)
            setCustomGroupSelected(customGroup);
        }
    }, []);

    const addPerspective = (perspective) => {
        // setCustomGroupSelected({
        //     ...customGroupSelected,
        //     perspectives: [perspective, ...customGroupSelected.perspectives],
        // });
        setCustomGroupSelected({
            ...customGroupSelected,
            perspectiveId: perspective.id,
        });
    };

    const removePerspective = (perspectiveToRemove) => {
        setCustomGroupSelected({
            ...customGroupSelected,
            perspectives: customGroupSelected.perspectives.filter((perspective) => {
                return perspective.id != perspectiveToRemove.id;
            }),
        });
    };

    const saveNewUserGroup = () => {
        const canSave = validName(customGroupSelected.name);

        if (canSave) {
            if (customGroupSelected.id) {
                updateDB(customGroupSelected);
            } else {
                saveDB(customGroupSelected);
            }
        }
    };

    const saveDB = (customGroup) => {
        createCustomGroupApi(customGroup).then((response) => {
            cancel();
        })
            .catch(error => {
                setMessageErrorResponseApi(error?.response?.data?.message || error?.response?.data);
            });
    };

    const updateDB = (customGroup) => {
        updateCustomGroupApi(customGroup).then((response) => {
            resetPoiApi(response.data)
            cancel();
        })
            .catch(error => {
                setMessageErrorResponseApi(error?.response?.data?.message || error?.response?.data);
            });
    };

    const validName = (name) => {
        let isValid = true;
        setMessageErrorName("");

        if (name === "") {
            setMessageErrorName("Name can't be empty");
            isValid = false;
        }

        return isValid;
    };

    const _handleOnChangeName = (event) => {
        const name = event.target.value;
        validName(name);
        setCustomGroupSelected({ ...customGroupSelected, name: event.target.value });
    };

    const cancel = () => {
        selectCustomGroup(null);
        reloadCustomGroupList();
        setMessageErrorResponseApi();
    };

    return (
        <CustomGroupBox>
            <div className="customGroup-data">
                <FormGroup
                    className={messageErrorName !== "" ? "custom-form-group-danger" : ""}
                    type="text"
                    disabled={false}
                    label="Name"
                    value={customGroupSelected.name}
                    onChange={_handleOnChangeName.bind(this)}
                    help={messageErrorName !== "" ? i18n(messageErrorName) : ""}
                />
                <div className="customGroup-users-perspective">
                    <PerspectivesBox
                        company={company}
                        customGroup={customGroupSelected}
                        addPerspective={addPerspective}
                        removePerspective={removePerspective}
                    />
                </div>
                <FormGroup
                    type="text"
                    disabled={false}
                    label="Description (optional)"
                    value={customGroupSelected.description}
                    onChange={(e) =>
                        setCustomGroupSelected({
                            ...customGroupSelected,
                            description: e.target.value,
                        })
                    }
                />
                <SubmitOrCancel
                    disabled={false}
                    // saving={null}
                    // saved={null}
                    // error={null || null}
                    // mustSave={null}
                    // valid={null}
                    onSubmit={() => saveNewUserGroup()}
                    onCancel={() => cancel()}
                    hideCancel={false}
                />

                <div class="custom-form-group-danger">
                    <span class="custom-form-group-danger help-block">{messageErrorResponseApi}</span>
                </div>
            </div>
        </CustomGroupBox>
    );
};


const CustomGroupBox = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;

  .customGroup-data {
    flex: 1 1 auto;
    padding: 20px;
  }

//   .customGroup-users-perspective {
//     flex: 0 1 300px;
//   }
`;

export default CustomGroup;
